import React, { useEffect, useState ,useImperativeHandle, forwardRef} from 'react';
import { Loading } from "../Loading";
import LoadingOverlay  from "../LoadingOverlay";

import BoxDesign from '../reports/BoxDesign';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import "../pages/CheckIn.css";
import { apiMain } from "../../App";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import OutlinedInput from '@mui/material/OutlinedInput';
import { useSnackbar } from "notistack";
import { useParams } from 'react-router-dom';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
const Permission=forwardRef((props,ref)=>{
  useImperativeHandle(ref, () => ({
     add: sendAdd,
    edit:   sendUpdate,
    // del: sendDelete,
    // new: cleardata,
  }));
  function sendUpdate() {
        setEditTable(true)
  }
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setAddflag(props.permission[9].Per_Add)
    setEditFlag(props.permission[9].Per_Edit)
    setDelFlag(props.permission[9].Per_Del)
    getUser();
    getObjectData();

  }, []);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [ObjectData, setObjectData] = useState([]);
  const [data, setData] = useState({});
  const params = useParams()
  // const [dialogLoading, setDialogLoading] = useState(false);
  // const [dialogError, setDialogError] = useState({});
  // const [NewFlag,setNewFlag]=useState(true);
  const [edittable, setEditTable]=useState(false);
  const [Addflag,setAddflag]=useState(false);
  const [EditFlag,setEditFlag]=useState(false);
  const [DelFlag,setDelFlag]=useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [U_Id, setU_Id] = useState(0);
  const [error, setError] = useState(false);
  const [listItems, setlistItems] = useState([])
  const [sel, setsel] = useState(false)
  const changeUser_Id = async (event) => {
    //setObjectData([]);
    setLoading(true)
    let uparams = new URLSearchParams();
    setU_Id(event.target.value)
    let response;
      uparams.append("U_Id", event.target.value);
    response = await GetDataPromise(`${apiMain}/api/v1/permission/select?${uparams}`, true);
    let parsed = JSON.parse(response);
    let newData = parsed.data;
    console.log(newData)
    if (newData.length >10)
    {
   // setObjectData(newData);



    setlistItems(newData);
    }
    else
    {  
      setlistItems(ObjectData)
    }
    setLoading(false)
  };
  const changesel = (event, id, type) => {
    let Items = [];

    Items = [...listItems];
    let selected = {...Items[id - 1]}
    switch (type) {
      case 'View':
        selected.Per_View = event.target.checked ? 1 : 0
        break;
      case 'Add':
        selected.Per_Add = event.target.checked ? 1 : 0
        break;
      case 'Edit':
        selected.Per_Edit = event.target.checked ? 1 : 0
        break;
      case 'Del':
        selected.Per_Del = event.target.checked ? 1 : 0
        break;
      default:
        break;
    }
    Items[id - 1] = selected;


    setlistItems(Items)
    console.log(listItems)
     };

  const sendAdd = async (e) => {

   // e.preventDefault()
   
    let formdata = new FormData();
    let errors = {};
    let azmon = 0;
    let tamon = 0;
    if (!U_Id) {
      setError(true);
      alert('Please Select User')
      return;
    }
    setLoading(true)
    let response;
    //Add & update
    formdata.append("U_Id", U_Id);
    response = await PostDataPromise(apiMain + "/api/v1/permission/delete", formdata);
    // console.log('listItems=',listItems)

    let parsed = JSON.parse(response);

    for (let i = 0; i < listItems.length; i++) {
      formdata.append("Object_Id", listItems[i].Object_Id);
      formdata.append("Per_View", listItems[i].Per_View);
      formdata.append("Per_Add", listItems[i].Per_Add );
      formdata.append("Per_Edit", listItems[i].Per_Edit);
      formdata.append("Per_Del", listItems[i].Per_Del);
  //     console.log('U_Id=',    formdata.get('U_Id'))
  //     console.log('Object_Id=',   listItems[i].Object_Id)
  // console.log('Per_View=',    listItems[i].Per_View)
  // console.log('Per_Add=',   listItems[i].Per_Add)
  // console.log('Per_Edit=',   listItems[i].Per_Edit )
  // console.log('Per_Del=',    listItems[i].Per_Del)

      response = await PostDataPromise(apiMain + "/api/v1/permission/insert", formdata)
      let parsed = JSON.parse(response);

    }

    alert('Information saved.')
    setLoading(false)

  }
  const [RoomTypedata, setRoomTypeData] = useState([]);
  const [PresentTypeData, setPresentTypeData] = useState([{ label: '', width: 160 }, { value: '', width: 300 }]);
  const [UserData, setUserData] = useState([]);
  const [selected, setSelected] = useState([]);
  const columns = [



    { field: 'id', headerName: 'ID', width: 50, editable: false },

    { field: 'Rtype_Name', headerName: 'Room Type', width: 190, editable: true },
    {
      field: 'Rtype_Fee',
      headerName: 'Fee',
      width: 150,
      type: 'number',
      editable: true,
    },



  ];
  const getObjectData = async () => {

    let res = await GetDataPromise(`${apiMain}/api/v1/objects/select`, false);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setObjectData(newData);
      setlistItems(newData);
      // let newitem=newData
//       newitem.map((obj)=>(
// obj.Per_View=0,
// obj.Per_Add=0,
// obj.Per_Edit=0,
// obj.Per_Del=0

//    ))

      setLoading(false)
    }
  }
  const getDataView = async (r_no) => {
    // let uparams = new URLSearchParams();

    // uparams.append("Room_No", r_no);
    let res = await GetDataPromise(`${apiMain}/api/v1/presents`, true);

    // let res = await GetDataPromise(`${apiMain}/api/v1/reservation`, force);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setData(newData)
      // setData(prev => {
      //     return {
      //         ...prev,
      //         attr: newData
      //     }
      // })
    }
  }
  const getUser = async () => {
    setLoading(true)
    let res = await GetDataPromise(`${apiMain}/api/v1/users`, false);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setUserData(newData)
    }
  }
  function clearitemall() {
  }

  const paginationModel = { page: 0, pageSize: 5 };
  {
    // if (loading) {

    //   return (
    //     <Loading small={true} />
    //     // <LoadingColor />
    //   )
    // }
    // else {
     // console.log(listItems)
      return (
        <>
          {/* <Header />    */}
          <BoxDesign className={"top-box"} style={{ fontWeight: 'bold', fontSize: '12px', height: '45px', marginLeft: '20px', width: '620px' }}>
            <div style={{ paddingTop: '10px' }} >
            </div>
            <div style={{ float: 'left', textAlign: 'left' }}>
              <div style={{ textAlign: 'left', marginLeft: '30px', paddingTop: '0px', float: 'left' }}>
                <div style={{ textAlign: 'left', float: 'left' }}>
                  <label id="demo-simple-select-label" style={{ width: '100px', float: 'left',fontSize:'12px'}} >User</label>
                  <FormControl sx={{ m: 0, width: '250px' }} >
                    <Select style={{ height: '30px', backgroundColor: '#F2F2F2', float: 'right' }}
                      labelId="demo-multiple-name-label"
                      value={U_Id}
                      onChange={changeUser_Id}
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {UserData.map((dat) => (
                        <MenuItem key={dat.U_id} value={dat.U_id}>{dat.U_Name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              
             
            </div>
          </div>
      
         {/* <div  style={{display:'flex',float:'left',marginTop:'10px'}}>
       <Stack direction="row" spacing={1} style={{paddingLeft:'30px',fontSize:'12px'}}>
                <Chip label="New" onClick={''} color="primary" disabled={true} sx={{width:80 ,cursor:'pointer',fontSize:'12px'}} />
                <Chip label="Add" onClick={''} color="primary" disabled={true} sx={{width:80 ,cursor:'pointer',fontSize:'12px'}} />
                <Chip label="Edit" onClick={sendUpdate} color="primary" disabled={!EditFlag} sx={{width:80 ,cursor:'pointer',fontSize:'12px'}} />
                <Chip label="Delete" onClick={''} color="error" disabled={true} sx={{width:80 , cursor:'pointer',fontSize:12}} />
           </Stack>
           </div> */}

            <BoxDesign className={"top-box"} style={{ fontWeight: 'bold', fontSize: '12px', marginTop: '10px', height: '870px', width: '625px', float: 'left' }}>
              <div style={{ float: 'left' }}>
              </div>
              <TableContainer component={Table}  >
                <Table size='small' >
                  <TableBody>
                    <TableRow
                
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px', width: '70px' }} >Id:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}> Description</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}> View</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}> Add</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}> Edit</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}> Del</TableCell>
                    </TableRow>
                    {/* <Loading small={true}/> */}
                    {listItems.map((dat) => (

                      <TableRow
                        key={2}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } ,height:5}} >
                        <TableCell align="left" style={{height:'5px' , fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}> {dat.Object_Id}</TableCell>
                        <TableCell align="left" style={{height:'5px' , fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}> {dat.Object_Name}</TableCell>
                        <TableCell align="left" style={{height:'5px' , fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}>
                          <input style={{ marginLeft: "30px", width: '30px' }}
                            type="checkbox"
                            name="Reserv_Cancel"
                            id={dat.Object_Id}
                            disabled={!edittable}
                            value={dat.Per_View}
                            checked={dat.Per_View }
                            onChange={(event) => changesel(event, dat.Object_Id, 'View')}
                            defaultValue={0}
                          //placeholder=""


                          />
                        </TableCell>
                        <TableCell align="left" style={{height:'5px' ,fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}>
                          <input style={{ marginLeft: "30px", width: '30px' }}
                            type="checkbox"
                            name="Reserv_Cancel"
                            id={dat.Object_Id}
                            disabled={!edittable}
                            value={dat.Per_Add}
                            checked={dat.Per_Add}
                            onChange={(event) => changesel(event, dat.Object_Id, 'Add')}
                            defaultValue={0}
                          //placeholder=""

                          />
                        </TableCell>
                        <TableCell align="left" style={{ height:'5px' ,fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}>
                          <input style={{ marginLeft: "30px", width: '30px' }}
                            type="checkbox"
                            name="Reserv_Cancel"
                            id={dat.Object_Id}
                            disabled={!edittable}
                            value={dat.Per_Edit}
                            checked={dat.Per_Edit}
                            onChange={(event) => changesel(event, dat.Object_Id, 'Edit')}
                            defaultValue={0}
                          //placeholder=""

                          />
                        </TableCell>
                        <TableCell align="left" style={{ height:'5px' ,fontWeight: 'bold', fontFamily: 'sans-serif', fontSize: '10px' }}>
                          <input style={{ marginLeft: "30px", width: '30px' }}
                            type="checkbox"
                            name="Reserv_Cancel"
                            id={dat.Object_Id}
                            disabled={!edittable}
                            value={dat.Per_Del}
                            checked={dat.Per_Del}
                            onChange={(event) => changesel(event, dat.Object_Id, 'Del')}
                            defaultValue={0}
                          //placeholder=""

                          />
                        </TableCell>

                      </TableRow>


                    ))}



                  </TableBody>
                </Table>
              </TableContainer>


            </BoxDesign>
          </BoxDesign>
           <LoadingOverlay isLoading={loading} text="Loading data..." />
         
        </>

      )
   // }
  }
})
 export default Permission